import axios from "axios";
import { urlDomain } from '../config/constant';

// Uploads via our own Node route, which proxies to uploading.imimg.com —
// VALIDATION_KEY needs the real AK, which the browser can never have now
// that jwt_token is httpOnly, so Node attaches it server-side instead
// (see routes.js's /uploadFile).
export const uploadFile = (empid, ak, glid, file) => {
    const apiUrl = `${urlDomain()}/uploadFile`;
    const data = new FormData();
    const requestData = {
        "IMAGE_NAME": file.name,
        "USR_ID": glid,
        "UPLOADED_BY": empid,
        "empid": empid,
        "glid": glid,
        "IMAGE": file
    }
    for(let key in requestData) {
        data.append(key, requestData[key]);
    }
    // uploading.imimg.com is a third party — never send credentials
    // (cookies) to it. This request goes to our own Node origin, whose
    // sibling requests use withCredentials via axios.defaults, so override
    // it back to true here since jwt_token must reach Node to be injected.
    return axios.post(apiUrl, data, { withCredentials: true });
}
